import { Joyride } from 'react-joyride';
import PropTypes from 'prop-types';
import walkthroughSteps from '@/walkthroughSteps';
import { settingsActions, useIsWalkthroughEnabled } from '@/stores/settingsStore';

const Walkthrough = ({ type, singlePass = true }) => {
  const steps = walkthroughSteps[type];
  const isEnabled = useIsWalkthroughEnabled(type);

  const handleCallback = event => {
    if (event.status === 'finished' || event.status === 'skipped') {
      if (singlePass) {
        settingsActions.disableWalkthrough(type);
      }
    }
  };

  if (!isEnabled) {
    return null;
  }

  return (
    <Joyride
      steps={steps}
      onEvent={handleCallback}
      run
      continuous
      scrollToFirstStep={true}
      options={{
        buttons: ['back', 'close', 'primary', 'skip'],
        primaryColor: 'rgba(0, 173, 116, 1)',
        showProgress: true,
        skipScroll: true,
      }}
    />
  );
};

Walkthrough.propTypes = {
  type: PropTypes.string,
  singlePass: PropTypes.bool,
};

export default Walkthrough;
